import axios from 'axios'
const EpisodeApi = {
    async getSingle(id) {
       const episode = await axios.get('/episode/' + id)
       return episode
    }
}

export default EpisodeApi